// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4f-2";
export var blackBorderOnHover = "_4f-7";
export var cell = "_4f-6";
export var cellContainer = "_4f-3";
export var checked = "_4f-8";
export var disabled = "_4f-5";
export var featuredIconCellContainer = "_4f-9";
export var featuredIconTextContainer = "_4f-b";
export var featuredIconWrapper = "_4f-a";
export var noBorder = "_4f-c";
export var orangeSelectedRow = "_av-3";
export var overflowableText = "_4f-0";
export var overflowableTextContainer = "_4f-1";
export var row = "_4h-0";
export var rowCheckboxCell = "_4f-4";
export var selectableTable = "_av-2";